export const appendOneCode = (referralCode: string) => {
  if (!referralCode) return
  if (referralCode?.substring(0, 4)?.toLowerCase() === 'one@')
    return referralCode

  return 'One@' + referralCode
}

export const updateZetCode = (code: string) => {
  if (!code) return
  else if (!code?.includes('@')) return code

  return code?.replace(/zet@|one@/gi, '')
}
